export default "__VITE_ASSET__bafcdb2c__"